import PropTypes from "prop-types";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { Button, CircularProgress, Grid, InputAdornment, useMediaQuery } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import LockIcon from "@mui/icons-material/Lock";
import TextField from "../../../../utils/ui-components/FormsUI/TextField";
import React, { useState } from "react";
import { UserService } from "../../../../assets/_services/user-service";
import { openSuccessDialog } from "../../../../utils/ui-components/pop-ups/SuccessDialog";
import { useTheme } from "@mui/material/styles";
import ButtonWrapper from "../../../../utils/ui-components/FormsUI/Button";

export interface UpdatePasswordValues {
  username: string;
  password: string;
  confirmPassword: string;
}

ChangePassword.propTypes = {
  initialItem: PropTypes.object.isRequired,
  fetchData: PropTypes.func,
  setOpen: PropTypes.func.isRequired,
};

function ChangePassword({ initialItem, fetchData, setOpen }: any) {
  const theme: any = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down("md"));

  const [passwordShow, setPasswordShow] = React.useState({
    password: "",
    showPassword: false,
    confirmPassword: "",
    showConfirmPassword: false,
  });

  const [isLoading, setIsLoading] = useState(false);

  const FORM_VALIDATION = Yup.object().shape({
    password: Yup.string()
      .max(50)
      .required("Password is required")
      .matches(/^\S*$/, "Password cannot contain spaces")
      .min(8, "Must contain at least 8 chanractres"),
    // .matches(
    //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
    //   "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
    // ),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], "Your passwords do not match.")
      .required("Please retype your password."),
  });

  const handleClickShowPassword = () => {
    setPasswordShow({
      ...passwordShow,
      showPassword: !passwordShow.showPassword,
    });
  };

  const handleClickShowConfirmPassword = () => {
    setPasswordShow({
      ...passwordShow,
      showConfirmPassword: !passwordShow.showConfirmPassword,
    });
  };

  const updatePassword = (itemData: UpdatePasswordValues, setSubmitting: (isSubmitting: boolean) => void, resetForm: (values: object) => void) => {
    let formData = {
      userId: initialItem.userId,
      password: itemData.password,
      role: initialItem.role,
    };

    setIsLoading(true);
    UserService.changeApproverPassword(formData).then((response) => {
      if (response.isSuccess) {
        openSuccessDialog("Success", "Approver password change successfully");
        setIsLoading(false);
        fetchData();
        resetForm({ itemData });
      } else {
        setSubmitting(false);
        setIsLoading(false);
      }
    });
  };

  return (
    <Formik
      initialValues={initialItem}
      enableReinitialize
      validationSchema={FORM_VALIDATION}
      onSubmit={(values: any, { setSubmitting, resetForm }) => {
        updatePassword(values, setSubmitting, resetForm);
      }}
    >
      {({ values, dirty, isSubmitting, isValid, setFieldValue }) => (
        <Form>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                required={!initialItem?.userId}
                type={passwordShow.showPassword ? "text" : "password"}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} edge="end">
                        {passwordShow.showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                name="password"
                // label="Password"
                placeholder="Password"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required={!initialItem?.userId}
                type={passwordShow.showConfirmPassword ? "text" : "password"}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton aria-label="toggle password visibility" onClick={handleClickShowConfirmPassword} edge="end">
                        {passwordShow.showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                name="confirmPassword"
                // label="Confirm Password"
                placeholder="Confirm Password"
              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                py: 2,
              }}
            >
              {!matchDownSM && (
                <Button
                  color="primary"
                  variant="contained"
                  type="button"
                  onClick={() => {
                    setOpen(false);
                  }}
                  sx={{ mr: 1 }}
                >
                  Close
                </Button>
              )}
              <ButtonWrapper color="primary" variant="contained" type="submit" disabled={!dirty || isSubmitting || !isValid}>
                {isLoading && (
                  <CircularProgress
                    size={"20px"}
                    sx={{
                      mr: 1,
                      color: "gray",
                    }}
                  />
                )}{" "}
                Save password
              </ButtonWrapper>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}

export default ChangePassword;
